/**
 * @author：
 * @update：
 * @description：
 **/
import {fileEcho,receptionClassList,delReceptionClassList,receptionClassListSort} from "../../api/url"
export default {
    data() {
        return {
            fileEcho:fileEcho,
            className:'',//分类名称
            enableVal:'',//启禁用
            enableOption:[{value:'true',label:'启用'},{value:'false',label:'禁用'}],
            tableData: [],//表格数据
            isChange:false,//是否上下移动过
        };
    },
    // 自定义方法
    methods: {
        //查询
        dataList(){

        },
        //重置
        resetBtn(){
            this.className='';//分类名称
            this.enableVal='';//启禁用
        },
        //获取列表
        getList(){
            let data = {

            };
            this.$ajax.get(receptionClassList,data).then(res=>{
                console.log(res);
                this.tableData = res.data;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //上移
        upItem(item) {
            let id = item.id;
            for(let i = 0; i < this.tableData.length; i++){
                if(id == this.tableData[i].id){
                    if(i==0){
                        return false
                    }
                    const upDate = this.tableData[i - 1];
                    this.tableData.splice(i - 1, 1);
                    this.tableData.splice(i, 0, upDate);
                    break;
                }else{
                    if(this.tableData[i].children){
                        for(let j = 0; j < this.tableData[i].children.length; j++){
                            if(id==this.tableData[i].children[j].id){
                                if(j==0){
                                    return false
                                }
                                const upDate = this.tableData[i].children[j - 1];
                                this.tableData[i].children.splice(j - 1, 1);
                                this.tableData[i].children.splice(j, 0, upDate);
                                break;
                            }else{
                                if(this.tableData[i].children[j].children){
                                    for(let k = 0; k < this.tableData[i].children[j].children.length; k++){
                                        if(id==this.tableData[i].children[j].children[k].id){
                                            if(k==0){
                                                return false
                                            }
                                            const upDate = this.tableData[i].children[j].children[k - 1];
                                            this.tableData[i].children[j].children.splice(k - 1, 1);
                                            this.tableData[i].children[j].children.splice(k, 0, upDate);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.isChange = true;
        },
        //下移
        downItem(item) {
            let id = item.id;
            for(let i = 0; i < this.tableData.length; i++){
                if(id == this.tableData[i].id){
                    if(i == this.tableData.length-1){
                        return false
                    }
                    const downDate = this.tableData[i + 1];
                    this.tableData.splice(i + 1, 1);
                    this.tableData.splice(i, 0, downDate);
                    break;
                }else{
                    if(this.tableData[i].children){
                        for(let j = 0; j < this.tableData[i].children.length; j++){
                            if(id==this.tableData[i].children[j].id){
                                if(j == this.tableData[i].children.length-1){
                                    return false
                                }
                                const downDate = this.tableData[i].children[j + 1];
                                this.tableData[i].children.splice(j + 1, 1);
                                this.tableData[i].children.splice(j, 0, downDate);
                                break;
                            }else{
                                if(this.tableData[i].children[j].children){
                                    for(let k = 0; k < this.tableData[i].children[j].children.length; k++){
                                        if(id==this.tableData[i].children[j].children[k].id){
                                            if(k == this.tableData[i].children[j].children.length-1){
                                                return false
                                            }
                                            const downDate = this.tableData[i].children[j].children[k + 1];
                                            this.tableData[i].children[j].children.splice(k + 1, 1);
                                            this.tableData[i].children[j].children.splice(k, 0, downDate);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.isChange = true;
        },
        //删除
        delList(id){
            this.$ajax.delete(delReceptionClassList(id),{id:id}).then(res=>{
                console.log(res);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.getList();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //删除弹窗
        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
        //编辑
        editOpen(id){
            this.$router.push({path:'/addReceptionClass',query:{id:id}})
        },
        //编辑后保存
        subBtn(){
            let data = this.tableData;
            this.$ajax.post(receptionClassListSort,data).then(res=>{
                console.log(res);
                this.getList();
                this.isChange=false;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        }
    },
    // 数据观察监听
    watch: {},
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.getList();
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
